/**
 * Botaniche — Cart Drawer
 * Handles cart drawer toggle, item removal, free shipping bar
 */
(function() {
  'use strict';

  function initCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add('cart-drawer--open');
      overlay.classList.add('cart-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Focus trap
      const closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 100);
    }

    function close() {
      drawer.classList.remove('cart-drawer--open');
      overlay.classList.remove('cart-overlay--visible');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Toggle from header cart button
    document.addEventListener('cart:toggle', function() {
      if (drawer.classList.contains('cart-drawer--open')) {
        close();
      } else {
        open();
      }
    });

    // Cart icon click (direct listener)
    const cartToggle = document.getElementById('cartToggle');
    if (cartToggle) {
      cartToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (drawer.classList.contains('cart-drawer--open')) {
          close();
        } else {
          open();
        }
      });
    }

    // Close button
    const closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    // Overlay click
    overlay.addEventListener('click', close);

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) {
        close();
      }
    });

    // Focus trap inside drawer
    drawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      const focusable = drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Cart remove buttons
    drawer.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (!removeBtn) return;

      e.preventDefault();
      const line = removeBtn.getAttribute('data-line');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        // Refresh page to update drawer
        window.location.reload();
      })
      .catch(function(err) {
        console.error('Remove from cart error:', err);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
